function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import React, { createRef, useMemo, useRef, useState } from "react";
import { useUIDSeed } from "react-uid";
import { Heading, Subheading } from "../../atoms";
import { InfoCardsGridItem, NavigationList, Section } from "../../molecules";
export var InfoCardsGrid = function(param) {
    var label = param.label, title = param.title, items = param.items, className = param.className, enableLines = param.enableLines, darkbackground = param.darkbackground, headlinevariant = param.headlinevariant;
    var seed = useUIDSeed();
    var containerRef = useRef(null);
    var bgColor = darkbackground ? "offdefault" : "default";
    var hVariant = headlinevariant || "h3";
    var groupedByCategoryItems = useMemo(function() {
        return items.reduce(function(accumulator, current) {
            var a = accumulator;
            a[current.category] = a[current.category] || [];
            a[current.category].push(current);
            return a;
        }, Object.create(null));
    }, [
        items
    ]);
    var ref;
    var initialVisibleCategory = (ref = Object.keys(groupedByCategoryItems)[0]) !== null && ref !== void 0 ? ref : "";
    var initialActiveIndex = Object.keys(groupedByCategoryItems).length > 0 ? 0 : -1;
    var ref1 = _slicedToArray(useState(initialVisibleCategory), 2), visibleCategory = ref1[0], setVisibleCategory = ref1[1];
    var ref2 = _slicedToArray(useState(initialActiveIndex), 2), activeCategoryIndex = ref2[0], setActiveCategoryIndex = ref2[1];
    var categoryRefs = useMemo(function() {
        return Object.entries(groupedByCategoryItems).map(function() {
            return /*#__PURE__*/ createRef();
        });
    }, [
        groupedByCategoryItems
    ]);
    var mappedItems = useMemo(function() {
        return Object.keys(groupedByCategoryItems).map(function(key, index) {
            return {
                active: index === activeCategoryIndex,
                label: key,
                onClick: function() {
                    setVisibleCategory(key);
                    setActiveCategoryIndex(index);
                }
            };
        });
    }, [
        groupedByCategoryItems,
        activeCategoryIndex,
        visibleCategory
    ]);
    return /*#__PURE__*/ React.createElement(Section, {
        container: true,
        lines: enableLines ? "dark" : false,
        className: className,
        backgroundColor: bgColor
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 gap-8 md:grid-cols-3"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "md:row-span-full"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "md:sticky md:top-[2rem]"
    }, !label && /*#__PURE__*/ React.createElement("span", {
        role: "presentation",
        className: "block pointer-events-none mb-4 border-b-2 border-fg-default w-[6.25rem]"
    }), !!label && /*#__PURE__*/ React.createElement(Subheading, {
        className: ""
    }, label), /*#__PURE__*/ React.createElement(Heading, {
        as: "h2",
        variant: hVariant,
        className: ""
    }, title), /*#__PURE__*/ React.createElement("div", {
        className: "-ml-4 md:-ml-5"
    }, /*#__PURE__*/ React.createElement(NavigationList, {
        variant: "sections",
        className: "mt-7 md:mt-8",
        items: mappedItems
    })))), /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-auto gap-8 md:col-span-2 md:col-start-2",
        ref: containerRef
    }, Object.keys(groupedByCategoryItems).map(function(categoryKey, categoryIndex) {
        return visibleCategory === categoryKey && /*#__PURE__*/ React.createElement("div", {
            key: seed(groupedByCategoryItems[categoryKey]),
            ref: categoryRefs[categoryIndex],
            className: "md:grid md:grid-cols-2 md:gap-6"
        }, groupedByCategoryItems[categoryKey].map(function(item) {
            return /*#__PURE__*/ React.createElement("div", {
                key: seed(item)
            }, /*#__PURE__*/ React.createElement(InfoCardsGridItem, _extends({}, item)));
        }));
    }))));
};

//# sourceMappingURL=InfoCardsGrid.js.map